export const ChooseProductStages = {
  main: 'main',
  singleItemType: 'single-item-type',
  singleItemValue: 'single-item-value',
};
